if (!customElements.get("cart-drawer-testimonials-slider")) {
  class SwiperSlider extends HTMLElement {
    connectedCallback() {
      this.waitForSwiper().then(() => this.initSwipers());
    }

    async waitForSwiper() {
      while (typeof Swiper === "undefined") {
        await new Promise((resolve) => setTimeout(resolve, 100));
      }
    }

    initSwipers() {
      const mainSliderElement = this.querySelector(".swiper-container");
      const thumbsSliderElement = document.querySelector(this.dataset.thumbsId);
      let thumbSwiper;

      if (thumbsSliderElement) {
        thumbSwiper = new Swiper(thumbsSliderElement, {
          slidesPerView: 4,
          spaceBetween: 5,
          loop: true,
          slideToClickedSlide: true,
        });
      }

      const mainSwiper = new Swiper(mainSliderElement, {
        loop: true,
        spaceBetween: 20,
        allowTouchMove: false,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      });

      if (thumbsSliderElement && thumbSwiper) {
        thumbsSliderElement.addEventListener("click", (event) => {
          const clickedSlide = event.target.closest(".swiper-slide");
          if (clickedSlide && clickedSlide.hasAttribute("data-swiper-slide-index")) {
            const clickedIndex = parseInt(clickedSlide.getAttribute("data-swiper-slide-index"), 10);
            if (!isNaN(clickedIndex)) {
              mainSwiper.slideTo(clickedIndex);
            }
          }
        });
      }
    }
  }

  customElements.define("cart-drawer-testimonials-slider", SwiperSlider);
}